import { render, staticRenderFns } from "./statusResult.vue?vue&type=template&id=c87c8e78&scoped=true&"
import script from "./statusResult.vue?vue&type=script&lang=ts&"
export * from "./statusResult.vue?vue&type=script&lang=ts&"
import style0 from "./statusResult.vue?vue&type=style&index=0&id=c87c8e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87c8e78",
  null
  
)

export default component.exports